import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/link/$parentId/invoices')({
  component: InvoicesLayout,
})

function InvoicesLayout() {
  return <Outlet />
}
